



































import {
  computed,
  defineComponent,
  ref
} from '@vue/composition-api'
import { TcPageAlert } from '@telia/shared-ui-components'

import { RoutePath as routes } from '@/router'

import {
  getIsAuthenticated,
  getFullName,
  getPersonalIdentityNumber,
  getToken
} from '@/store/modules/authentication-v6.store'
import {
  accessorFactory,
  Namespace
} from '@/store'

import { AnslPage } from '@/components'
import ContactForm from './ContactForm.vue'
import ContactFormPageAuthentication from './ContactFormPageAuthentication.vue'
import ContactFormThankYou from '@/components/common/AfterFormSubmission.vue'

import { submitContactForm } from '@/services/contact-form.service'

import {
  ContactFormRequest
} from '@/types/contact-form-page.types'

import beforeEnterContactForm from '@/views/contact-form-page/contact-form-page-guard'
import AnslPageCf from '@/components/AnslPageCf.vue'
import ContactFormCf from '@/views/contact-form-page/ContactFormCf.vue'
import { CfAnslContactForm } from '@/types/ansl-space/types/cf-ansl-contact-form'
import { Entry } from 'contentful'

const {
  getContent,
  getLoading,
  getException
} = accessorFactory<Entry<CfAnslContactForm>>(Namespace.ContactFormContent)

export default defineComponent({
  components: {
    ContactFormCf,
    AnslPageCf,
    TcPageAlert,
    AnslPage,
    ContactForm,
    ContactFormPageAuthentication,
    ContactFormThankYou
  },
  beforeRouteEnter: async (_to, _from, next) => {
    next(async (vm: Vue) => {
      await beforeEnterContactForm(vm, next)
    })
  },
  setup (_, context) {
    const store = context.root.$store

    const loading = computed(() => getLoading(store))
    const loaded = computed(() => !getLoading(store) && !getException(store))
    const exception = computed(() => getException(store))
    const content = computed(() => getContent(store))
    const isFormSubmitted = ref(false)
    const isFormBeingSubmitted = ref(false)
    const errorResponse = ref<string | null>(null)
    const isDevelopmentMode = process.env.VUE_APP_DEVELOPMENT_MODE_BYPASS_BANK_ID === 'true'

    const bannerTitle = computed(() => getContent(store)?.fields.banner.fields.title || '')
    const bannerDescription = computed(() => getContent(store)?.fields.banner.fields.description)
    const isAuthenticated = computed(() => getIsAuthenticated(store))
    const requesterName = computed(() => getFullName(store))
    const personalIdentityNumber = computed(() => getPersonalIdentityNumber(store))
    const afterSubmissionContent = computed(() => content.value?.fields.afterSubmissionInformation)

    const handleFormSubmission = async (formData: ContactFormRequest) => {
      try {
        isFormBeingSubmitted.value = true
        await submitContactForm(formData, getToken(store))
        isFormSubmitted.value = true
        window.scroll(0, 0)
      } catch (err) {
        errorResponse.value = err
      } finally {
        isFormBeingSubmitted.value = false
      }
    }

    return {
      loading,
      loaded,
      exception,
      afterSubmissionContent,
      routes,
      isFormSubmitted,
      isFormBeingSubmitted,
      errorResponse,
      requesterName,
      personalIdentityNumber,
      isAuthenticated,
      handleFormSubmission,
      isDevelopmentMode,
      content,
      bannerTitle,
      bannerDescription
    }
  }
})

